
// import libs
// import cookieBar from './libs/cookieBar';
// import { CountUp } from './libs/CountUp.js';

var $header = $('#header');
var headerHeight = $header.outerHeight();

// import components
import './components/ie-edge-detection.js';
import './components/menu.js';
// import './components/smoothScroll.js';

// https://ehsangazar.com/optimizing-javascript-event-listeners-for-performance-e28406ad406c
function throttle (callback, limit) {
  var wait = false;
  return function () {
    if (!wait) {
      callback.apply(null, arguments);
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  }
}

// https://ehsangazar.com/optimizing-javascript-event-listeners-for-performance-e28406ad406c
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

// init
// cookieBar.init({
//   // settings
//   // infoText: 'Soubory cookies nám pomáhají poskytovat, chránit a zlepšovat naše služby. Prohlížením tohoto webu s jejich používáním souhlasíte.',
//   // buttonText: 'Rozumím',
//   ipCheck: false,
// });

$('.lazy').Lazy({
  // your configuration goes here
  scrollDirection: 'vertical',
  effect: 'fadeIn',
  effectTime: 150,
  visibleOnly: true,
  threshold: 500,
  bind: 'event',
  onError: function(element) {
      console.log('error loading ' + element.data('src'));
  }
});

// Animations
setTimeout(function(e) {
  new WOW().init({
    offset: 300,
  });
}, 500);

// ----------------------------------------
//  scroll to
function scrollTo(e) {
  e.preventDefault();

  var href = $.attr(this, 'href');
  if (typeof href === 'undefined') {
      href = $.attr(this, 'data-href');
  }
  href = href.replace('/', '');
  var offset = $.attr(this, 'data-offset');

  var $target = $(href);
  if ($target.length) {
      $('html,body').animate({
        scrollTop: $target.offset().top - headerHeight + ((typeof offset !== 'undefined') ? parseInt(offset) : 10)
      }, {
        duration: 500,
        easing: 'swing'
      });
  }
}

// ----------------------------------------

// scripts here
// flash
setTimeout(function(e) {
  $('.flash').addClass('active');
}, 1000);

$('.flash__close').on('click', function(e) {
  $(this).closest('.flash').removeClass('active');
});

// bounce rate event
// var stayOnPage = 10000;
// setTimeout(function(e) {
//   var label = 'na webu alespoň ' + (stayOnPage / 1000) + 's';
//   gtag('event', 'bounce rate fix', {'event_category': 'navstevnik','event_label': label});
// }, stayOnPage);


// gallery
$('#gallery').slick({
  lazyLoad: 'ondemand',
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  dots: false,
});

// Numbers animation
// if ($('.page--homepage').length) {
//   var waypointNumbers = new Waypoint({
//     element: document.getElementById('numbers'),
//     handler: function(direction) {

//       // numbers
//       var objs = [];
//       var $numbers = $('.number__value:not(.number__value--notAnimated)');
//       for (var i = 0; i < $numbers.length; i++) {
//         var id = $($numbers[i]).attr('id');
//         var val = parseInt($($numbers[i]).attr('data-value'));
//         var duration = parseInt($($numbers[i]).attr('data-duration'));
//         var delay = parseInt($($numbers[i]).attr('data-delay'));

//         objs.push(new CountUp(id, val, {
//           duration: duration / 1000,
//           separator: ' ',
//           delay: delay,
//         }));
//       }

//       // first number
//       setTimeout(function(e) {
//         objs[0].start(function(e) {
//           $(this.el).addClass('done');
//         });
//       }, objs[0].options.delay);

//       // second number
//       setTimeout(function(e) {
//         objs[1].start(function(e) {
//           $(this.el).addClass('done');
//         });
//       }, objs[1].options.delay);

//       // // third number
//       // setTimeout(function(e) {
//       //   objs[2].start();
//       // }, objs[2].options.delay);

//       // // fourth number
//       // setTimeout(function(e) {
//       //   objs[3].start();
//       // }, objs[3].options.delay);

//       this.destroy();
//     },
//     offset: 250
//   });
// }


// init controller
if ($('.page--homepage').length) {
  var controller = new ScrollMagic.Controller();

  var scene = new ScrollMagic.Scene({triggerElement: "#fosfolipidy", duration: 200, offset: 0, triggerHook: .05})
              .setPin("#fosfolipidy")
              // .addIndicators({name: "PIN"})
              .addTo(controller);

  // scale
  var scene1 = new ScrollMagic.Scene({triggerElement: "#fosfolipidy", duration: 600, offset: -600, triggerHook: .05})
              .setTween("#handCapsule", {scale: 0})
              // .addIndicators({name: "SCALE"})
              .addTo(controller);

  // opacity
  var scene2 = new ScrollMagic.Scene({triggerElement: "#fosfolipidy", duration: 35, offset: -125, triggerHook: .05})
              .setTween("#handCapsule", {opacity: 0})
              // .addIndicators({name: "OPACITY"})
              .addTo(controller);

  // Box and tooltips animation
  var waypointAbout = new Waypoint({
    element: document.getElementById('about'),
    handler: function(direction) {

      console.log('about');

      var $sectionAbout = $('#about');
      $sectionAbout.addClass('active');

      // First tooltip
      setTimeout(function() {
        $sectionAbout.find('.boxInfo__tooltip--1').addClass('active');
      }, 500);

      // Second tooltip
      setTimeout(function() {
        $sectionAbout.find('.boxInfo__tooltip--2').addClass('active');
      }, 800);

      // Third tooltip
      setTimeout(function() {
        $sectionAbout.find('.boxInfo__tooltip--3').addClass('active');
      }, 1100);

      // Forth tooltip
      setTimeout(function() {
        $sectionAbout.find('.boxInfo__tooltip--4').addClass('active');
      }, 1400);

      this.destroy();
    },
    offset: 500
  });

}